/*-----------------
* ADD SCROLLED CLASS TO BODY TAG
*----------------*/

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const threshold = 10; // px — change if needed

  function onScroll() {
    if (window.scrollY > threshold) {
      body.classList.add('scrolled');
    } else {
      body.classList.remove('scrolled');
    }
  }

  window.addEventListener('scroll', onScroll);
  onScroll(); // run once on load
});

/* END OF ADD SCROLLED CLASS TO BODY TAG */